var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-input-number", {
            attrs: {
              min: _vm.min,
              placeholder: _vm.placeholder,
              value: _vm.value,
              controls: _vm.controls
            },
            on: { change: _vm.update }
          })
        : _c("p", [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }